<template>
  <div class="container">
    <div class="columns">
      <div class="column is-8">
        <div id="crash" class="content-block">
          <div id="info">Max: $300</div>
          <div id="stararea" ref="stararea" v-show="playing && !crashed && connected"></div>
          <svg v-if="playing && !crashed && connected" data-v-b7cba45a="" width="150" height="150" class="rocket" :class="{ 'shaking-slow': (currentPoint < 2), shaking: (currentPoint > 2 && currentPoint < 20), 'shaking-hard': (currentPoint > 20) }">
            <image data-v-b7cba45a="" xlink:href="../assets/rocket.svg" width="150" height="150"></image>
          </svg>
          <div v-if="connected" id="crash-area">
            <h2 class="crash red" v-if="crashed">CRASH @ {{ currentPoint }}</h2>
            <h1 class="has-text-weight-bold" v-if="playingShow">{{ currentPoint }} x</h1>
            <p v-if="startTimer">Waiting to start game... {{ timerWaiting }}</p>
          </div>
          <div v-else>Connecting to server...</div>
          <div v-if="connected" id="betting" class="mt-4">
            <button v-if="startTimer" @click="makeBet()" class="button is-large orange" :disabled="!loggedIn">Bet</button>
            <button v-else :disabled="currentBet <= 0" @click="cashOut()" class="button is-large orange">Cash out</button>
            <div class="columns is-mobile mt-4">
              <div class="column is-5">
                <b-field v-if="loggedIn" label="Wallet" class="mb-0">
                  <b-select expanded v-model="walletType">
                    <option v-for="(wallet, index) in wallets" :value="wallet.type" :key="index">
                      {{ wallet.type }}
                    </option>
                  </b-select>
                </b-field>
                <small v-if="getWalletBalance">Balance: {{ getWalletBalance.usableBalance }}</small>
              </div>
              <b-field v-if="loggedIn" label="Bet" class="column is-7">
                <b-input v-model="bet"></b-input>
              </b-field>
            </div>
          </div>
          <div id="history">
            <div class="columns is-mobile">
              <div v-for="(historyCrash, index) in history" :key="index" class="column" :class="{ red: historyCrash < 2, green: historyCrash >= 2, seethrough: (index == (history.length - 1) && history.length > 0) }">{{ historyCrash }} x</div>
            </div>
          </div>
        </div>
      </div>
      <div class="column is-4">
        <div id="chat" class="content-block">
          <h1 class="title is-6">Chat</h1>
          <div id="chat-content">
            <div v-for="(chatMessage, index) in chat" :key="index" class="row level chat columns is-mobile">
              <div class="column is-paddingless">
                {{ chatMessage.username }} : {{ chatMessage.message }}
              </div>
            </div>
          </div>
          <b-input v-if="loggedIn" v-model="chatMessage" @keydown.native.enter="sendChat()" size="is-small" class="mt-4" />
        </div>
      </div>
    </div>
    <div id="bets" class="content-block column is-8">
      <h1 class="title is-6">Bets</h1>
      <transition-group name="fade">
        <div v-for="bet in bets" :key="bet.client" class="row level bg columns is-mobile">
          <div class="column is-6 is-paddingless">{{ bet.user.username }}</div>
          <div class="column is-3 is-paddingless has-text-centered">
            <span class="green" v-if="bet.cashOutPoint">{{ bet.cashOutPoint }} x</span>
          </div>
          <div v-if="!bet.cashOut" class="column is-3 is-paddingless is-flex is-align-items-center is-justify-content-end">
            <figure style="float: left" class="image is-16x16 mr-2"><img :src="require(`@/assets/${bet.type}.png`)" /></figure> {{ bet.bet }}
          </div>
          <div v-else class="column is-3 is-paddingless green  is-flex is-align-items-center is-justify-content-end">
            <figure style="float: left" class="image is-16x16 mr-2"><img :src="require(`@/assets/${bet.type}.png`)" /></figure> {{ bet.cashOut }}
          </div>
        </div>
      </transition-group>
    </div>
  </div>
</template>
<script>
import { WebglPlot, WebglLine, ColorRGBA } from "webgl-plot"
import { mapState } from "vuex"
import { SET_CURRENTBET } from "../store/App/mutation.type"

export default {
  data() {
    return {
      bet: 0.0001,
      walletType: 'btc',
      chatMessage: '',
      usingWalletBalance: 0
    }
  },
  mounted() {
    this.addStars(1000, 1000, 200)
    this.animateStars(1000, 1000, 2)
  },
  methods: {
    sendChat() {
      this.$socket.emit("chat", { message: this.chatMessage })
      this.chatMessage = ''
    },
    async makeBet() {
      if(this.bet == 0) return this.$buefy.toast.open({ type: 'is-danger', message: 'Cannot bet nothing' })

      if (Number(this.getWalletBalance.usableBalance) < Number(this.bet)) {
        return this.$buefy.toast.open({ type: 'is-danger', message: 'Insufficient wallet balance' })
      }

      this.$store.commit(`app/${SET_CURRENTBET}`, this.bet)
      this.$socket.emit("bet", { bet: this.bet, type: this.walletType })
    },
    cashOut() {
      this.$socket.emit("cashOut")
    },
    addStars(starFieldWidth, starFieldHeight, noOfStars) {
      var starField = this.$refs.stararea
      var numberOfStars = noOfStars

      for (var i = 0; i < numberOfStars; i++) {
        var star = document.createElement('div')
        star.className = 'star'
        var topOffset = Math.floor((Math.random() * starFieldHeight) + 1)
        var leftOffset = Math.floor((Math.random() * starFieldWidth) + 1)
        star.style.top = topOffset + 'px'
        star.style.left = leftOffset + 'px'
        star.style.position = 'absolute'
        starField.appendChild(star)
      }
    },
    animateStars(starFieldHeight, starFieldWidth, speed) {
      var starField = this.$refs.stararea
      var stars = starField.childNodes

      function getStarColor(index) {
        if (index % 8 == 0)
          return 'red'
        else if (index % 10 == 0)
          return 'yellow'
        else if (index % 17 == 0)
          return 'blue'
        else
          return 'white'
      }

      function getStarDistance(index) {
        if (index % 6 == 0)
          return ''
        else if (index % 9 == 0)
          return 'near'
        else if (index % 2 == 0)
          return 'far'
        else
          return 0
      }

      function getStarRelativeSpeed(index) {
        if (index % 6 == 0)
          return 1
        else if (index % 9 == 0)
          return 2
        else if (index % 2 == 0)
          return -1
        else
          return 0
      }

      setInterval(() => {
        for (var i = 1; i < stars.length; i++) {
          stars[i].className = 'star' + ' ' + getStarColor(i) + ' ' + getStarDistance(i)

          var currentTop = parseInt(stars[i].style.top, 10)
          var topChangeAmount = (speed + getStarRelativeSpeed(i)) * (1 + ((this.currentPoint - 1)))
          if (topChangeAmount > 10) topChangeAmount = 10
          var topDiff
          if (currentTop + topChangeAmount > starFieldHeight) {
            topDiff = currentTop + topChangeAmount - starFieldHeight
          }
          else {
            topDiff = currentTop + topChangeAmount
          }
          stars[i].style.top = (topDiff) + 'px'
        }

      }, 10)
    }
  },
  computed: {
    ...mapState("app", ["connected", "bets", "currentBet", "startTimer", "crashed", "playing", "chat", "timerWaiting"]),
    currentPoint() {
      return this.$store.state.app.currentPoint.toFixed(2)
    },
    playingShow() {
      return !this.startTimer && !this.crashed && this.playing
    },
    allowedToBet() {
      return this.startTimer || this.crashed || !this.playing
    },
    wallets() {
      return this.$store.state.user.wallets
    },
    loggedIn() {
      return this.$store.state.user.loggedIn
    },
    getWalletBalance() {
      return this._.find(this.wallets, { type: this.walletType })
    },
    history() {
      return this.$store.state.app.history.reverse()
    }
  },
  watch: {
    walletType() {
      const usingWallet = this._.find(this.wallets, { type: this.walletType })
      this.usingWalletBalance = usingWallet.usableBalance
    }
  }
}
</script>
<style lang="scss" scoped>
#content-container {
  min-height: 100vh;
  width: 60%;
}
#crash {
  position: relative;
  display: flex;
  height: 500px;
  width: 100%;
  align-items: center;
  justify-content: center;
  flex-grow: 1;
  flex-flow: column;
  overflow: hidden;
  #info {
    height: 30px;
    padding: 5px 10px;
    background: #121214;
    border-radius: 10px;
    position: absolute;
    top: 5px;
    left: 5px;
    font-size: 0.8rem;
  }
  #stararea {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  #crash-area {
    position: relative;
    height: 200px;
    display: flex;
    align-items: center;
    z-index: 5;
    .crash {
      font-size: 4rem;
    }
    h1 {
      font-size: 4rem;
    }
  }
  #betting {
    display: flex;
    align-items: center;
    flex-direction: column;
    position: relative;
  }
  #history {
    background: #121214;
    position: absolute;
    bottom: 0;
    width: 100%;
    overflow: hidden;
    .columns {
      margin: 0;
      .column {
        text-align: center;
        font-size: 0.8rem;
        padding: 12px 2px;
        min-width: 60px;
        &.seethrough {
          opacity: 0.6;
        }
      }
    }
  }
}

#bets {
  background: #1d1e22;
  border: 0;
  .row {
    padding: 7px 15px;
    border-radius: 5px;
    font-size: 0.9rem;
    &.bg:nth-child(2n + 1) {
      background: #141518;
    }
  }
}

#chat {
  background: #1d1e22;
  border: 0;
  .row {
    &.chat {
      padding: 2px 15px;
      font-size: 0.8rem;
    }
  }
}

.rocket {
  position: absolute;
  right: 10%;
  top: 30%;
  &.shaking-slow {
    animation: shake-slow 0.5s;
    animation-iteration-count: infinite;
  }
  &.shaking {
    animation: shake 0.5s;
    animation-iteration-count: infinite;
  }
  &.shaking-hard {
    animation: shake-hard 0.5s;
    animation-iteration-count: infinite;
  }

  @media only screen and (max-width: 800px) {
    top: 20%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}

@keyframes shake-slow {
  0% {
    margin-left: 10px;
    margin-top: 0.5px;
  }
  10% {
    margin-left: -0.5px;
    margin-top: -1px;
  }
  20% {
    margin-left: 1.5px;
    margin-top: 0;
  }
  30% {
    margin-left: 1.5px;
    margin-top: 1px;
  }
  40% {
    margin-left: 0.5px;
    margin-top: -0.5px;
  }
  50% {
    margin-left: -0.5px;
    margin-top: 1px;
  }
  60% {
    margin-left: -1.5px;
    margin-top: 0.5px;
  }
  70% {
    margin-left: 1.5px;
    margin-top: 0.5px;
  }
  80% {
    margin-left: -0.5px;
    margin-top: -0.5px;
  }
  90% {
    margin-left: 0.5px;
    margin-top: 1px;
  }
  100% {
    margin-left: 0.5px;
    margin-top: -1px;
  }
}

@keyframes shake {
  0% {
    margin-left: 1px;
    margin-top: 1px;
  }
  10% {
    margin-left: -1px;
    margin-top: -2px;
  }
  20% {
    margin-left: 3px;
    margin-top: 0;
  }
  30% {
    margin-left: 3px;
    margin-top: 2px;
  }
  40% {
    margin-left: 1px;
    margin-top: -1px;
  }
  50% {
    margin-left: -1px;
    margin-top: 2px;
  }
  60% {
    margin-left: -3px;
    margin-top: 1px;
  }
  70% {
    margin-left: 3px;
    margin-top: 1px;
  }
  80% {
    margin-left: -1px;
    margin-top: -1px;
  }
  90% {
    margin-left: 1px;
    margin-top: 2px;
  }
  100% {
    margin-left: 1px;
    margin-top: -2px;
  }
}

@keyframes shake-hard {
  0% {
    margin-left: 4px;
    margin-top: 2px;
  }
  10% {
    margin-left: -2px;
    margin-top: -4px;
  }
  20% {
    margin-left: 6px;
    margin-top: 0;
  }
  30% {
    margin-left: 6px;
    margin-top: 4px;
  }
  40% {
    margin-left: 2px;
    margin-top: -2px;
  }
  50% {
    margin-left: -2px;
    margin-top: 4px;
  }
  60% {
    margin-left: -6px;
    margin-top: 2px;
  }
  70% {
    margin-left: 6px;
    margin-top: 2px;
  }
  80% {
    margin-left: -2px;
    margin-top: -2px;
  }
  90% {
    margin-left: 2px;
    margin-top: 4px;
  }
  100% {
    margin-left: 2px;
    margin-top: -4px;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.5s;
}
.fade-enter,
.fade-leave-to {
  transform: translateY(15px);
  background: #393569;
}
</style>
